var map = {
	"./12mindful.jpg": "1aCJ",
	"./alan-bk.jpg": "ckAx",
	"./alan.jpg": "WWjH",
	"./bg.jpg": "zF6V",
	"./boardgame.jpg": "RdTf",
	"./knowledge.jpg": "kXmX",
	"./logo.png": "cbpf",
	"./mid.jpg": "EyWO",
	"./mindful.jpg": "P2K/"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VtH2";